module.exports = __webpack_public_path__ + "media/icons/arrow-01-ed755c2d.svg";